const PointTitle = () => {
  return <p className="text-[13px] font-medium leading-[18px] text-primary">You&apos;ve earned points!</p>
}

export default PointTitle
